/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrandEmailDto
 */
export interface BrandEmailDto {
    /**
     * Identifier for brand link
     * @type {string}
     * @memberof BrandEmailDto
     */
    linkId?: string;
    /**
     * Id of branded email template
     * @type {string}
     * @memberof BrandEmailDto
     */
    emailTypeId?: string;
    /**
     * Url which can be used to download the branded email template
     * @type {string}
     * @memberof BrandEmailDto
     */
    imageUrl?: string;
}

/**
 * Check if a given object implements the BrandEmailDto interface.
 */
export function instanceOfBrandEmailDto(value: object): boolean {
    return true;
}

export function BrandEmailDtoFromJSON(json: any): BrandEmailDto {
    return BrandEmailDtoFromJSONTyped(json, false);
}

export function BrandEmailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandEmailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'linkId': json['linkId'] == null ? undefined : json['linkId'],
        'emailTypeId': json['emailTypeId'] == null ? undefined : json['emailTypeId'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

export function BrandEmailDtoToJSON(value?: BrandEmailDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'linkId': value['linkId'],
        'emailTypeId': value['emailTypeId'],
        'imageUrl': value['imageUrl'],
    };
}

